import { routeConstant } from "shared/routes/routeConstant";
import ProjectsList from "shared/components/dashboardCommon/projectsList";

const DesignerProjects = () => {
  return (
    <ProjectsList
      userType="designer"
      pageTitle="All Projects"
      pageDescription="Your creative workspace — all current builds in one place."
      showSearchFilter={true}
      EnableApiIntegration={true}
      noContentMessage="You don't have any projects at the moment. Start creating to see them here."
      detailRoutePath={routeConstant.designer.projectDetail.path}
    />
  );
};

export default DesignerProjects;
